export const RoleValidationMessageConst = {
	name: [{ type: 'required', message: 'Role Name is required' }],
	menus: [{ type: 'required', message: 'Menu is required' }],
	access: [{ type: 'required', message: 'Permission is required' }],
};
